// Ported from design/project/App37-EmptyHistory.dc.html by design/preview/to_tsx.py. Change the design first, then this.
import { fit } from "../fit.js";

export function App37_EmptyHistory() {
  return (
    <>
      <div className="screen">
  <div className="orbL" aria-hidden="true" style={{ top: "160px", left: "-45px", width: "480px", height: "480px" }}></div>
  <div className="pad" style={{ height: "100%", paddingBottom: "calc(var(--dd-nav-bottom) + 84px)" }}>
    <div className="top">
      <span className="syne" style={{ fontWeight: "800", fontSize: "17px" }}>History</span>
      <span></span>
    </div>

    <div style={{ marginTop: fit(12, 70), position: "relative", height: fit(130, 220), display: "flex", alignItems: "center", justifyContent: "center" }}>
      <svg width="260" height="220" viewBox="0 0 260 220" style={{ height: fit(130, 220), width: "auto" }} role="img" aria-label="An empty arena: two faded arrows facing each other">
        <ellipse cx="130" cy="186" rx="110" ry="18" fill="none" stroke="rgba(255,255,255,0.08)" strokeWidth="2"></ellipse>
        <ellipse cx="130" cy="186" rx="70" ry="10" fill="none" stroke="rgba(204,255,0,0.25)" strokeWidth="2" strokeDasharray="4 6"></ellipse>
        <g opacity="0.35"><path d="M70 40 L106 84 H84 V150 H56 V84 H34 Z" fill="none" stroke="#CCFF00" strokeWidth="3" strokeLinejoin="round"></path></g>
        <g opacity="0.35"><path d="M190 160 L226 116 H204 V50 H176 V116 H154 Z" fill="none" stroke="#FF3366" strokeWidth="3" strokeLinejoin="round"></path></g>
        <text x="130" y="112" textAnchor="middle" fontFamily="Syne" fontWeight="800" fontSize="22" fill="rgba(255,255,255,0.25)">?</text>
      </svg>
    </div>

    <h2 className="h2" style={{ marginTop: "18px", textAlign: "center", fontSize: "24px" }}>No battles yet</h2>
    <p className="muted" style={{ margin: "8px 20px 0", textAlign: "center", fontSize: "14px", lineHeight: "21px" }}>Your wins, roasts and replays live here. Start with a $2 battle to warm up.</p>

    <div style={{ marginTop: fit(16, 28), display: "flex", flexDirection: "column", gap: "10px" }}>
      <a href="#/App09" className="btnP">START FIRST BATTLE</a>
      <a href="#/App02" className="btnS">How battles work</a>
    </div>
  </div>

  <nav className="nav g" aria-label="Main">
    <a href="#/App09"><svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M14.5 17.5 L3 6V3h3l11.5 11.5"></path><path d="M13 19l6-6M16 16l4 4M19 21l2-2"></path></svg>Arena</a>
    <a href="#/App23"><svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" aria-hidden="true"><path d="M8 21h8M12 17v4M7 4h10v5a5 5 0 0 1-10 0z"></path><path d="M17 5h3v2a3 3 0 0 1-3 3M7 5H4v2a3 3 0 0 0 3 3"></path></svg>Ranks</a>
    <a href="#/App25" className="on"><svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" aria-hidden="true"><circle cx="12" cy="12" r="9"></circle><path d="M12 7v5l3 2"></path></svg>History</a>
    <a href="#/App24"><svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" aria-hidden="true"><circle cx="12" cy="8" r="4"></circle><path d="M4 21c1.5-4 4.5-6 8-6s6.5 2 8 6"></path></svg>Profile</a>
  </nav>
</div>
    </>
  );
}
